import { render, staticRenderFns } from "./demo-home.vue?vue&type=template&id=260052c2&scoped=true"
import script from "./demo-home.vue?vue&type=script&lang=ts"
export * from "./demo-home.vue?vue&type=script&lang=ts"
import style0 from "./demo-home.vue?vue&type=style&index=0&id=260052c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260052c2",
  null
  
)

export default component.exports